import { ListItem } from '@lmc/ui-kit/src/dataDisplay'
import CollapsibleItem, {
  type ToggleCollapseFn
} from '@lmc/ui-kit/src/dataDisplay/CollapsibleItem/CollapsibleItem'
import { Text } from '@lmc/ui-kit/src/general'
import { capitalize } from 'lodash'
import type { ReactNode } from 'react'
import EventIcon from 'screens/Rostering/RotaBuilder/common/components/EventIcon'
import ServiceUserInfo from 'screens/Rostering/RotaBuilder/screens/AllocationWindow/components/ServiceUserInfo'
import type {
  ClockInTeamMember,
  RotaInstanceStatus
} from 'screens/Rostering/types'
import styled from 'styled-components'
import ClockInWarningsPopover from './ClockInWarningsPopover'

type TeamMemberAccordionProps = {
  user: any
  warnings: ClockInTeamMember['warnings']
  status: string
  children: ReactNode
}

const TeamMemberAccordion = ({
  user,
  warnings,
  status,
  children
}: TeamMemberAccordionProps) => {
  return (
    <CollapsibleSection
      header={(toggleCollapse: ToggleCollapseFn, collapsed: boolean) => (
        <ListItemStyled
          onClick={toggleCollapse}
          toggleCollapse={toggleCollapse}
          isCollapsed={collapsed}
          title={<ServiceUserInfo serviceUser={user} avatarSize={22} />}
          rightChildren={
            <RightSection>
              <ClockInWarningsPopover warnings={warnings} />
              <StatusContainer>
                <Text weight="medium">{capitalize(status)}</Text>
                <EventIcon status={status as RotaInstanceStatus} />
              </StatusContainer>
            </RightSection>
          }
          slim
        />
      )}
    >
      {children}
    </CollapsibleSection>
  )
}

const CollapsibleSection = styled(CollapsibleItem)`
  border: 1px solid ${({ theme }) => theme.color.neutral.color8};
  border-radius: 8px;
`
const ListItemStyled = styled(ListItem)`
  padding: 16px;

  cursor: pointer;
`
const StatusContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-right: 8px;
`
const RightSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export default TeamMemberAccordion
